
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/referral",
      function () {
        return require("private-next-pages/stores/[cName]/referral/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/referral"])
      });
    }
  